type ScrollbarSize = { width: number; height: number; };

// Measuring forces a full layout and every dropdown calls it on mount, so share one measurement per
// frame; later frames re-measure, which picks up zoom and scrollbar-style changes.
let cached: ScrollbarSize | undefined;

const getScrollbarSize = (): ScrollbarSize => {
  if (cached) {
    return cached;
  }

  // Creating invisible container
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll'; // forcing scrollbar to appear
  document.body.appendChild(outer);

  // Creating inner element and placing it in the container
  const inner = document.createElement('div');
  outer.appendChild(inner);

  // Calculating difference between container's full width and the child width
  const width = outer.offsetWidth - inner.offsetWidth;
  const height = outer.offsetHeight - inner.offsetHeight;

  // Removing temporary elements from the DOM
  outer.parentNode?.removeChild(outer);

  cached = { width, height };
  requestAnimationFrame(() => {
    cached = undefined;
  });

  return cached;
};

export default getScrollbarSize;
